// userService.js
import { get } from './common';



export const getHistory = (filterData ) => {
    return get('history/admin-expert', filterData);
};

export const listHistoryUser = (filterData) => {
    return get('user/list-history-users', filterData);
};


